var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93237 8.48982C1.86616 8.33494 1.83203 8.16825 1.83203 7.99982C1.83203 7.83139 1.86616 7.6647 1.93237 7.50982C2.47103 6.22982 3.33237 5.15315 4.4097 4.41182C5.48703 3.67049 6.73503 3.29649 7.9997 3.33582C9.26437 3.29649 10.5117 3.67049 11.5897 4.41182C12.6677 5.15315 13.5284 6.22982 14.067 7.50982C14.1332 7.6647 14.1674 7.83139 14.1674 7.99982C14.1674 8.16825 14.1332 8.33494 14.067 8.48982C13.5284 9.76982 12.667 10.8465 11.5897 11.5878C10.5124 12.3292 9.26437 12.7032 7.9997 12.6638C6.73503 12.7032 5.4877 12.3292 4.4097 11.5878C3.3317 10.8465 2.47103 9.76982 1.93303 8.48982",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 10.3327C8.30577 10.3327 8.60918 10.2723 8.89228 10.1551C9.17537 10.0378 9.43259 9.86593 9.64926 9.64926C9.86593 9.43259 10.0378 9.17537 10.1551 8.89228C10.2723 8.60918 10.3327 8.30577 10.3327 7.99935C10.3327 7.69293 10.2723 7.38951 10.1551 7.10642C10.0378 6.82333 9.86593 6.5661 9.64926 6.34943C9.43259 6.13276 9.17537 5.96089 8.89228 5.84363C8.60918 5.72637 8.30577 5.66602 7.99935 5.66602C7.38051 5.66602 6.78702 5.91185 6.34943 6.34943C5.91185 6.78702 5.66602 7.38051 5.66602 7.99935C5.66602 8.61819 5.91185 9.21168 6.34943 9.64926C6.78702 10.0868 7.38051 10.3327 7.99935 10.3327Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWhite);
export default __webpack_public_path__ + "static/media/eye_white.61fbc0bc880e5d1761511d26c1c5397f.svg";
export { ForwardRef as ReactComponent };